import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-accordion',
  templateUrl: './ui-accordion.component.html',
  styleUrls: ['./ui-accordion.component.css']
})
export class UiAccordionComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
